import { useEffect, useState } from 'react';

interface IPosition {
	offsetLeft: number;
	offsetTop: number;
}

interface IPositions {
	circle1: IPosition;
	circle2: IPosition;
}

export const usePositions = (
	containerRef: React.RefObject<HTMLDivElement>,
): IPositions | undefined => {
	const [alertPositions, setAlertPositions] = useState<IPositions>();

	useEffect(() => {
		const { x: containerX, y: containerY } = containerRef.current?.getBoundingClientRect() ?? {};
		const { x: circle1X, y: circle1Y } =
			document.getElementsByClassName('circle1')?.[0]?.getBoundingClientRect() ?? {};
		const { x: circle2X, y: circle2Y } =
			document.getElementsByClassName('circle2')?.[0]?.getBoundingClientRect() ?? {};

		containerX &&
			containerY &&
			setAlertPositions({
				circle1: {
					offsetLeft: circle1X - containerX,
					offsetTop: circle1Y - containerY,
				},
				circle2: {
					offsetLeft: circle2X - containerX,
					offsetTop: circle2Y - containerY,
				},
			});
	}, []);

	return alertPositions;
};
